import { cn } from "@lib/cn"
import type { ReactNode } from "react"

/**
 * The one pill (PRD-59). 32 sites hand-rolled pills with 8 distinct
 * treatments while `Badge` had 2 importers; variants now name a MEANING, so
 * a reader learns the colour once and it holds across every surface:
 *
 *   accent    — the primary object's own state (a count, a level)
 *   success   — done, graded, on track
 *   attention — needs the professor (to review, to grade, a low average)
 *   danger    — failed, did not submit
 *   neutral   — a fact with no valence
 *   outline   — a label on a tinted ground, where a fill would fight it
 */
type Variant = "accent" | "success" | "attention" | "danger" | "neutral" | "outline"

const variants: Record<Variant, string> = {
  accent: "bg-accent-soft text-accent-ink",
  success: "bg-success-soft text-success-ink",
  attention: "bg-attention-soft text-attention-ink",
  danger: "bg-danger-soft text-danger-ink",
  neutral: "bg-inset text-ink-muted",
  outline: "border border-border text-ink-muted",
}

export function Badge({
  children,
  variant = "neutral",
  className,
}: {
  children: ReactNode
  variant?: Variant
  className?: string
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
